import { EntityStore, StoreConfig, entitiesToArray } from '@datorama/akita';
import { Content } from '../../squidex';
import { IBaseState } from './base.state';
import { FilterPagination } from './filter.pagination';
const cloneDeep = require('lodash.clonedeep');

export abstract class BaseStore extends EntityStore<IBaseState, Content> {

  protected constructor(baseState?: IBaseState, schemaName?: string) {
    if (baseState && schemaName) {
      super(baseState, { name: schemaName });
    } else {
      super();
    }
  }

  hasPaginateContents(filter: FilterPagination): boolean {
    const state = this.getValue();

    if (!state.lastFilter
      || !state.lastOrderBy
      || state.lastFilter !== filter.filter
      || state.lastOrderBy !== filter.orderBy) {
      this.reset();
      return false;
    }

    for (let i = filter.from; i < filter.to; i++) {
      if (!Object.keys(state.storedIndex)
        .some(index => Number.parseInt(index) === i)) {
          return false;
      }
    }

    return true;
  }

  updatePaginate(contents: Content[], filter: FilterPagination) {

    let storedIndex = cloneDeep(this.getValue().storedIndex);
    let i = 0;

    if (!storedIndex) {
      storedIndex = {};
    }

    for (let j = filter.from; j <= filter.to && i < contents.length; j++ , i++) {
      storedIndex[j] = contents[i].id;
    }

    this.update({
      storedIndex: storedIndex,
      lastFilter: filter.filter,
      lastOrderBy: filter.orderBy
    });

    this.add(contents);
  }

}
